/* eslint-disable react/jsx-props-no-spreading */
import { cloneElement } from 'react';
import PropTypes from 'prop-types';
// Utils & misc
import { cn } from '@repo/zolintra-utils';
// Components
import { MenuButton } from '../../molecules/MenuButton/MenuButton';
// Styles
import styles from './Menu.module.css';

export function Menu({
  className, children, footer, isOpen, logo, onMenuButtonClick, menuButtonLabel, version,
}) {
  return (
    <nav
      className={cn([
        styles.nav,
        className,
        isOpen && styles.open,
        !isOpen && styles.close,
      ])}
    >
      <div className={cn([styles.logo])}>
        {logo}
      </div>
      <MenuButton
        icon="arrowSquareLeft"
        onClick={onMenuButtonClick}
        isOpen={isOpen}
        color="neutral"
      >
        {menuButtonLabel}
      </MenuButton>
      <div className={cn([styles.content])}>
        {children}
      </div>
      {footer ? (
        <>
          <div className={cn([styles.footer])}>
            {cloneElement(footer, { isOpen })}
          </div>
          <span className={cn([styles.version])}>{`v.${version}`}</span>
        </>
      ) : null}
    </nav>
  );
}

Menu.propTypes = {
  logo: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  footer: PropTypes.node,
  isOpen: PropTypes.bool,
  onMenuButtonClick: PropTypes.func,
  menuButtonLabel: PropTypes.string,
  version: PropTypes.string,
};

Menu.defaultProps = {
  className: null,
  footer: null,
  isOpen: true,
  onMenuButtonClick: undefined,
  menuButtonLabel: null,
  version: '0.0.0',
};

export default Menu;
